import { render, staticRenderFns } from "./ActPrint.vue?vue&type=template&id=2122353a&scoped=true"
import script from "./ActPrint.vue?vue&type=script&lang=js"
export * from "./ActPrint.vue?vue&type=script&lang=js"
import style0 from "./ActPrint.vue?vue&type=style&index=0&id=2122353a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122353a",
  null
  
)

export default component.exports